// src/redux/reducers/essentialMenuReducer.js
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import daySlice from "../slice/utility/day-slice";
import callLogSlice from "../slice/utility/call-log-slice";
import SoundSlice from "../slice/utility/soundNotificationSlice";

const soundPersistConfig = {
  key: "soundNotification",
  storage,
  whitelist: ["notificationsEnabled", "volume", "callNotificationSound", "posSound", "notificationSound"], 
};

const utilityReducer = combineReducers({
  day: daySlice,
  callLog: callLogSlice,
  soundNotification: persistReducer(soundPersistConfig, SoundSlice),
});

export default utilityReducer;
